import { getTailwindColor } from '@/utils/colors';
import imageSrc from './warning.svg';
import clsx from 'clsx';
import { LevelType, HeadingHelper } from '../../heading-helper/heading-helper';
import { useGlobalQueries } from '@/hooks/use-global-queries';

export type LegilativeCouncilReferralProps = {
    header: string;
    text: string;
    bgColor: string;
    headingLevel: number;
    variant?: 'card' | 'inline';
    showIcon?: boolean;
};

export const LegilativeCouncilReferral = ({
    header: snapshotHeader,
    text: snapshotText,
    bgColor,
    headingLevel = 3,
    variant = 'card',
    showIcon = true,
}: LegilativeCouncilReferralProps) => {
    const { getSetting } = useGlobalQueries();
    const settings = getSetting('legislative_council_referral');

    // Empty settings fall back per field to the page snapshot (incl. the WP default text).
    const header = settings?.header || snapshotHeader;
    const text = settings?.text || snapshotText;

    if (variant === 'inline') {
        return (
            <div
                data-component="legilative-council-referral"
                className="styled-link r-text-black [&_p]:r-m-0"
                dangerouslySetInnerHTML={{ __html: text ?? '' }}
            />
        );
    }

    const heading = (className: string) =>
        header ? (
            <HeadingHelper level={headingLevel as LevelType} classList={clsx('r-font-medium r-text-base', className)}>
                {header}
            </HeadingHelper>
        ) : null;

    return (
        <div data-component="legilative-council-referral" className={clsx(getTailwindColor(bgColor, 'bg'))}>
            <div className="r-container r-p-4 sm:r-p-8">
                <div className="r-rounded-2xl r-bg-white r-p-6 r-shadow-md lg:r-flex lg:r-items-center lg:r-gap-6 lg:r-p-8">
                    {(showIcon || header) && (
                        <div className="r-items-end r-gap-4 max-lg:r-flex max-lg:r-pb-3 md:r-gap-6">
                            {showIcon && <img alt="" className="r-w-20 lg:r-w-44" src={imageSrc} />}
                            {heading('lg:r-hidden')}
                        </div>
                    )}
                    <div>
                        {heading('max-lg:r-hidden')}
                        <div className="styled-link r-space-y-4" dangerouslySetInnerHTML={{ __html: text ?? '' }} />
                    </div>
                </div>
            </div>
        </div>
    );
};
